import { motion } from "framer-motion";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.65, delay, ease: [0.16, 1, 0.3, 1] },
});

export const About = () => (
  <section id="sobre" className="py-24 sm:py-32" data-testid="about-section">
    <div className="max-w-3xl mx-auto px-5 sm:px-8 flex flex-col items-center text-center">
      <motion.p {...fadeUp()} className="font-mono-dt text-xs uppercase tracking-[0.35em] text-[#e03131] mb-10">
        Sobre o Estúdio
      </motion.p>

      <motion.img {...fadeUp(0.05)} src="/logo-dudu.png" alt="Logo Eduardo Camargo Studio Tattoo"
        className="w-44 sm:w-56 h-auto" data-testid="about-logo" />

      <motion.div {...fadeUp(0.15)} className="mt-12 w-full max-w-md">
        <div className="relative rounded-lg overflow-hidden border border-[#27272a]">
          <img src="/about-eduardo.jpg" alt="Eduardo Camargo tatuando" loading="lazy"
            className="w-full h-auto object-cover" data-testid="about-photo" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#09090b]/50 via-transparent to-transparent" />
        </div>
        <p className="mt-3 font-mono-dt text-[10px] uppercase tracking-[0.3em] text-zinc-600">
          Eduardo Camargo — em sessão
        </p>
      </motion.div>

      <motion.p {...fadeUp(0.25)} className="mt-10 text-base sm:text-lg text-zinc-300 leading-relaxed" data-testid="about-text">
        Eduardo Camargo é tatuador especialista em preto e branco, com 3 anos dedicados a transformar
        ideias em arte permanente. Cada traço é pensado com precisão para criar contraste, profundidade
        e detalhes que ficam para sempre na pele.
      </motion.p>
    </div>
  </section>
);
